import SignInContainer from './components/sign-in-container'
import SignInFormContainer from './components/sign-in-form-container'
import SignInSubmitButton from './components/sign-in-submit-button'
import SignInFooter from './components/sign-in-footer'
import { z } from 'zod'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import FormInputPassword from './components/form-input-password'
import SignInBackButton from './components/sign-in-back-button'
import { signInInputSchema } from './data/sign-in-schema'
import { useMutation } from '@tanstack/react-query'
import { updatePassword } from '@/hooks/getAuth'
import { toast } from 'react-toastify'
import SigninAgreePolicy from './components/sign-in-agree-policy'

interface Props {
  email: string
  onSuccess: (data: any) => void
  onClickBack: () => void
}

const formSchema = z.object({
  email: signInInputSchema.shape.email,
  password: signInInputSchema.shape.password,
})

type FormValues = z.infer<typeof formSchema>

export default function SignInAddPassword({
  email,
  onSuccess,
  onClickBack,
}: Props) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({
    mode: 'onChange',
    resolver: zodResolver(formSchema),
    defaultValues: {
      email,
    },
  })

  const { mutate, isPending } = useMutation({
    mutationFn: (form: FormValues) =>
      updatePassword(form.email, '', form.password),
    onSuccess: (data) => {
      onSuccess({
        userCredential: data,
        oldPassword: '',
      })
    },
    onError: (error: Error) => toast.warn(error.message),
  })
  const onSubmit = (data: FormValues) => {
    return mutate(data)
  }

  return (
    <SignInContainer loading={isPending}>
      <SignInFormContainer title="Password">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex space-y-4 flex-col py-4">
            <div className="flex flex-col py-4 space-y-4">
              <FormInputPassword
                placeholder="Minimum 8 characters"
                register={register('password')}
                error={errors.password}
              />
            </div>

            <SigninAgreePolicy />

            <SignInSubmitButton text="Start 3 Day Free Trial" />

            <SignInBackButton onClick={onClickBack} />
          </div>
        </form>
      </SignInFormContainer>
      <SignInFooter />
    </SignInContainer>
  )
}
